import api from "../index";

export const GetAdminDashboardApi = () => api.post("superadmin-dashboard");
export const GetLicenseApi = () => api.post("admin-list-with-license");
export const GetAdminLoginApi = (data) => api.post("access-admin-panel", data);
